export default "__VITE_ASSET__DKlO$PH9__"